import { FC } from 'react';
import { CurrentAddressBooksView } from './current-address-books-view';

export const AddressBookPanel: FC = () => (
  <>
    <div className="pt-4">
      <CurrentAddressBooksView />
    </div>
  </>
);
